import { ProductSetDetails, ProductSetsListItem } from "../productsSets.types";

export const convertProductSetDetailsToListItem = (
  productSet: ProductSetDetails | null | undefined
): ProductSetsListItem | null => {
  if (!productSet) return null;

  return {
    id: productSet.id,
    title: productSet.title,
    description: productSet.description,
    coverMedia: productSet.coverMedia,
    createdAt: productSet.createdAt,
    showOnHome: productSet.showOnHome,
    showInSearch: productSet.showInSearch,
    numberOfProducts: productSet.productVariants.length,
    order: productSet.order
  };
};
